import Header from "components/HeaderHorizontal";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Carousel, Card, Form, Button } from "react-bootstrap";
import "./styles.scss";

import { Context } from "context/AuthContext";
import { GET_RESUMO } from "services/Quiz";
import HtmlPreview from "components/HTMLExtract";

const ContentResumo = () => {
  const navigate = useNavigate();
  const { showLoader } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [listQuestoes, setListQuestoes] = useState([]);
  const [index, setIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [quizSubmitted, setQuizSubmitted] = useState(false);

  useEffect(() => {
    setLoading(true);
    showLoader(true);

    const fetchQuiz = async () => {
      try {
        const data = await GET_RESUMO();
        setListQuestoes(data.value.questoes);

        const initialSelectedAnswers = {};
        data.value.questoes.forEach((questao) => {
          const selectedAnswer = questao.respostas.find(
            (resposta) => resposta.selecionado
          );
          if (selectedAnswer) {
            initialSelectedAnswers[questao.questaoId] =
              selectedAnswer.respostaId;
          }
        });
        setSelectedAnswers(initialSelectedAnswers);
      } catch (error) {
        console.error("Erro ao buscar o quiz:", error);
      } finally {
        setLoading(false);
        showLoader(false);
      }
    };

    fetchQuiz();
  }, []);

  const handlePrev = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  const handleNext = () => {
    if (index < listQuestoes.length - 1) {
      setIndex(index + 1);
    }
  };

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="quiz-wrapper-resumo">
      <Header />
      {!quizSubmitted && (
        <>
          {loading ? (
            <span className="d-flex justify-content-center align-items-center ">Carregando...</span>
          ) : (
            <div className="quiz-container-resumo">

              <div className="quiz-content-resumo">
                <Carousel
                  activeIndex={index}
                  onSelect={handleSelect}
                  indicators={false}
                  interval={null}
                  nextIcon={null}
                  prevIcon={null}
                  touch={false}
                >
                  {listQuestoes.map((questao) => (
                    <Carousel.Item key={questao.questaoId}>
                      <div className="quiz-container-cards-resumo">
                        <Card className="question-card-resumo ">
                          <Card.Subtitle className="question-subtitle-resumo">
                            {questao.categoriasTree.reduce((acc, categoria, index) => {
                              // Extrai a primeira parte da string até o primeiro "-"
                              const baseCategoria = categoria.split(" - ")[0];

                              // Adiciona a categoria completa somente se a base ainda não foi processada
                              if (index === 0 || baseCategoria !== acc.baseAnterior) {
                                acc.texto += categoria + " ";
                                acc.baseAnterior = baseCategoria;
                              } else {
                                // Caso seja uma repetição, adiciona apenas o texto após o " - "
                                acc.texto += " - " + categoria.split(" - ")[1] + "";
                              }
                              return acc;
                            }, { texto: "", baseAnterior: "" }).texto}
                          </Card.Subtitle>
                          <Card.Body
                            key={questao.questaoId}
                            className="question-container-resumo"
                          >
                            <HtmlPreview
                              htmlContent={questao.enunciado}
                              mode="card"
                            />
                            {/* {questao.urlImagemEnunciado &&
                            !questao.enunciado ? (
                              <Card.Img
                                className="question-img-resumo"
                                src={rota + questao.urlImagemEnunciado}
                              />
                            ) : null}
                            {questao.enunciado && (
                              <Card.Text className="question-text-resumo">
                                {questao.enunciado}
                              </Card.Text>
                            )} */}
                          </Card.Body>
                        </Card>
                        <div className="vertical-line"></div>
                        <Card className="answer-card-resumo ">
                          <Card.Body className="answer-card-content">
                            {questao.respostas.map((resposta) => (
                              <div
                                key={resposta.respostaId}
                                className={`answer-container-resumo ${resposta.correto
                                  ? "correct-answer"
                                  : "incorrect-answer"
                                  } ${selectedAnswers[questao.questaoId] ===
                                    resposta.respostaId
                                    ? "selected-answer"
                                    : ""
                                  }`}
                              >
                                <Form.Check
                                  readOnly
                                  type="radio"
                                  id={`resposta-${resposta.respostaId}`}
                                  className="d-flex align-items-center"
                                >
                                  <Form.Check.Input
                                    readOnly
                                    type="radio"
                                    name={`questao-${questao.questaoId}`}
                                    checked={
                                      selectedAnswers[questao.questaoId] ===
                                      resposta.respostaId
                                    }
                                  />
                                  <Form.Check.Label className=" form-check-label-resumo">
                                    <HtmlPreview
                                      htmlContent={resposta.texto}
                                      mode="card"
                                      className="form-ckeck-label-resumo"
                                    />
                                    {/* {resposta.urlImagem && !resposta.texto ? (
                                      <Card.Img
                                        src={rota + resposta.urlImagem}
                                        alt="Resposta"
                                        className="thumbnail"
                                        style={{
                                          width: "100%",
                                          height: "10dvh",
                                        }}
                                      />
                                    ) : (
                                      resposta.texto
                                    )} */}
                                  </Form.Check.Label>
                                </Form.Check>
                              </div>
                            ))}
                            {/* Container para mostrar a resolução */}
                            <div className="resolution-container-resumo">
                              <HtmlPreview
                                htmlContent={questao.resolucao}
                                mode="card"
                              />
                              {questao.linkVideoAula && (
                                <span className="link-container">
                                  Ficou com dúvidas? <br />
                                  Assista a uma videoaula sobre este conteúdo
                                  <a href={questao.linkVideoAula} target="_blank">
                                    aqui.
                                  </a>
                                </span>
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>

                {/* Botões de navegação abaixo do Carousel */}
                <div className="content-btn-resumo">
                  <Button
                    variant="primary"
                    onClick={handlePrev}
                    disabled={index === 0}
                    className="btn-quiz"
                  >
                    Voltar
                  </Button>
                  {/* Indicadores personalizados */}
                  <div className="d-flex flex-column justify-content-center align-items-center m-0">
                    <span>
                      {index + 1} de {listQuestoes.length}
                    </span>
                    <div className="carousel-indicators-custom-quiz">
                      {listQuestoes.map((questao, idx) => (
                        <span
                          key={idx}
                          className={`carousel-indicator-resumo ${selectedAnswers[questao.questaoId] !== undefined
                            ? selectedAnswers[questao.questaoId] ===
                              questao.respostas.find(
                                (resposta) => resposta.correto
                              )?.respostaId
                              ? "correct"
                              : "incorrect"
                            : ""
                            } ${index === idx ? "current-step-resumo" : ""}`}
                          onClick={() => setIndex(idx)}
                        ></span>
                      ))}
                    </div>
                  </div>
                  {index === listQuestoes.length - 1 ? (
                    <Button
                      variant="primary"
                      onClick={() => {
                        navigate("/");
                      }}
                      className="btn-quiz"
                    >
                      Finalizar
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      onClick={handleNext}
                      className="btn-quiz"
                    >
                      Próximo
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContentResumo;
